import React, { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Hero } from "../common";
import { ContactForm } from "./components/contact-form/ContactForm";

export const LostCard: FC = () => {
  const { t } = useTranslation("p_lost-card");

  return (
    <div
      className={classNames(
        "space-y-15 pb-15",
        "lg:space-y-25 lg:pb-25",
        "xl:space-y-40 xl:pb-40",
      )}
    >
      <Hero title={t("hero_title")} subtitle={t("hero_body")} />
      <ContactForm />
    </div>
  );
};
